import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { UserService } from 'src/app/_services/user.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { GlobalService } from 'src/app/service/global.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {
  currentUser: any;
  constructor(private globalService: GlobalService, private userService: UserService, private token: TokenStorageService, private notificationService: NotificationService) { globalService._disableBackButton(); }

  ngOnInit(): void {
  }

  public redirectPublic(): void {
    console.log("redirectPublic called");

    this.userService.getPublicContent().subscribe(
      (response: any) => {
        console.log(response);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        console.log(msg);
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public redirectUser(): void {
    console.log("redirectUser called");

    this.userService.getUserBoard().subscribe(
      (response: any) => {
        console.log(response);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        console.log(msg);
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public redirectModeraotr(): void {
    console.log("redirectModeraotr called");

    this.userService.getModeratorBoard().subscribe(
      (response: any) => {
        console.log(response);
      }, err => {
        console.log(JSON.parse(err.error).message);
      }
    )
  }

  public redirectAdmin(): void {
    console.log("redirectAdmin called");

    this.userService.getAdminBoard().subscribe(
      (response: any) => {
        console.log(response);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        console.log(msg);
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

}
